// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Id from "../../../../node_modules/rescript/lib/es6/belt_Id.js";
import * as Belt_Set from "../../../../node_modules/rescript/lib/es6/belt_Set.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as ScrollLock$Showside from "../utils/ScrollLock.bs.js";
import * as ProductCard$Showside from "./ProductCard.bs.js";
import * as ListPageGrid$Showside from "./ListPageGrid.bs.js";
import * as QuickViewTypes$Showside from "../types/QuickViewTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ProductListItem$Showside from "./ProductListItem.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ProductCardCTAButton$Showside from "./ProductCardCTAButton.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewMediaDetails$Showside from "./QuickViewMediaDetails.bs.js";
function cmp(param, param$1) {
  if (param[0].id === param$1[0].id && param[1].id === param$1[1].id) {
    return 0;
  } else {
    return 1;
  }
}
var ProductCompare = Belt_Id.MakeComparable({
  cmp: cmp
});
function QuickViewProductList(Props) {
  var media = Props.media;
  var activeMediaChild = Props.activeMediaChild;
  var config = Props.config;
  var columns = Props.columns;
  var maxRows = Props.maxRows;
  var onProductSelectedOpt = Props.onProductSelected;
  var getProductListButtonLabel = Props.getProductListButtonLabel;
  var productListButtonStyle = Props.productListButtonStyle;
  var onClickProductListButton = Props.onClickProductListButton;
  var onProductSelected = onProductSelectedOpt !== undefined ? onProductSelectedOpt : function (param, param$1) {};
  var match = RouterProvider$Showside.useRouter(undefined);
  var route = match.route;
  var match$1;
  if (typeof route === "number" || route.TAG !== /* QuickView */3) {
    match$1 = [undefined, undefined];
  } else {
    var match$2 = route._0;
    match$1 = [match$2.productId, match$2.variantId];
  }
  var variantId = match$1[1];
  var productId = match$1[0];
  var match$3 = ViewportContext$Showside.use(undefined);
  var isMobile = match$3.isMobile;
  var match$4 = EntrypointContext$Showside.use(undefined);
  var isMiniPDPVisible = match$4.isMiniPDPVisible;
  var onOpenLink = match$4.onOpenLink;
  var onAddToCart = match$4.onAddToCart;
  var trackEvent = match$4.trackEvent;
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match$5 = ConfigurationProvider$Showside.use(undefined);
  var match$6 = match$5.config.settings;
  var openProductLink = match$6.openProductLink;
  var hideOutOfStock = match$6.hideOutOfStock;
  var productCardShape = match$6.productCardShape;
  var productCardFitToContainer = match$6.productCardFitToContainer;
  var handleToggleProduct = React.useCallback(function (product) {
    return function (variant) {
      if (Caml_obj.equal(productId, product.id) && Caml_obj.equal(variantId, Belt_Option.map(variant, function (variant) {
        return variant.id;
      }))) {
        return Curry._2(onProductSelected, undefined, undefined);
      } else {
        return Curry._2(onProductSelected, product, variant);
      }
    };
  }, [productId, onProductSelected]);
  var handleSelectProduct = React.useCallback(function (product) {
    return function (variant) {
      Curry.app(trackEvent, ["Clicked In-Media Product Card", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      return Curry._2(onProductSelected, product, variant);
    };
  }, [onProductSelected]);
  var handleProductClick = React.useCallback(function (product) {
    return function (variant) {
      Curry.app(trackEvent, ["Clicked In-Media Product Card", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      if (openProductLink) {
        return Curry._5(onOpenLink, undefined, undefined, product, variant, undefined);
      } else {
        return Curry._2(handleToggleProduct, product, variant);
      }
    };
  }, [onOpenLink, handleToggleProduct, openProductLink]);
  var productsInMedia = Curry._4(QuickViewTypes$Showside.productVariantsInMedia, hideOutOfStock, config, media, displayVariantBy);
  var productCards = Belt_Array.mapWithIndex(Belt_Set.toArray(Belt_Set.fromArray(productsInMedia, ProductCompare)), function (index, param) {
    var variant = param[1];
    var product = param[0];
    var isSelected = Caml_obj.equal(productId, product.id) && Caml_obj.equal(variantId, variant.id);
    var tmp = {
      shape: productCardShape,
      product: product,
      activeVariantId: variant.id,
      onClick: handleSelectProduct,
      onAddToCart: onAddToCart,
      onOpenLink: onOpenLink,
      dataCount: index
    };
    if (isMiniPDPVisible !== undefined) {
      tmp.isMiniPDPVisible = Caml_option.valFromOption(isMiniPDPVisible);
    }
    return React.createElement(ConditionalRender$Showside.When.make, {
      condition: isMobile,
      children: React.createElement(ProductCard$Showside.make, tmp),
      fallback: React.createElement(ProductListItem$Showside.make, {
        isSelected: isSelected,
        product: product,
        variant: variant,
        shape: productCardShape,
        imageFitStrategy: productCardFitToContainer ? /* Contain */2 : /* Cover */1,
        hideOutOfStock: hideOutOfStock,
        onClick: handleProductClick,
        displayVariantBy: displayVariantBy
      }),
      key: String(index)
    });
  });
  var renderCards = function (param) {
    var tmp = {
      columns: columns,
      children: productCards,
      paddingOverride: 0
    };
    if (maxRows !== undefined) {
      tmp.maxRows = maxRows;
    }
    return React.createElement(ConditionalRender$Showside.When.make, {
      condition: isMobile,
      children: React.createElement(ListPageGrid$Showside.make, tmp),
      fallback: productCards
    });
  };
  var productListButtonLabel = Belt_Option.flatMap(getProductListButtonLabel, function (fn) {
    return Curry._1(fn, media.id);
  });
  var contentLabel = "Product" + (productCards.length > 1 ? "s" : "");
  var match$7 = media.kind;
  var mediaLabel = typeof match$7 === "object" ? "album" : match$7 === "video" ? "video" : match$7 === "placeholder" ? "placeholder" : match$7 === "image" ? "image" : "embed";
  var tmp;
  if (productsInMedia.length !== 0) {
    var tmp$1;
    if (productListButtonLabel !== undefined && onClickProductListButton !== undefined) {
      var tmp$2 = {
        label: productListButtonLabel,
        onClick: function (param) {
          Curry._1(onClickProductListButton, media.id);
          Curry.app(trackEvent, ["Clicked CTA Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
        },
        primary: true
      };
      if (productListButtonStyle !== undefined) {
        tmp$2.style = Caml_option.valFromOption(productListButtonStyle);
      }
      tmp$1 = React.createElement("div", {
        className: CSS$Showside.prefix("mt-8")
      }, React.createElement(ProductCardCTAButton$Showside.make, tmp$2));
    } else {
      tmp$1 = null;
    }
    tmp = React.createElement("div", {
      className: CSS$Showside.prefix("mb-22")
    }, React.createElement("div", {
      className: CSS$Showside.prefix("font-semibold mb-4 text-xl text-primary")
    }, "" + contentLabel + " in this " + mediaLabel + ""), React.createElement("div", {
      className: CSS$Showside.prefix("flex flex-col space-y-2")
    }, renderCards(undefined)), tmp$1);
  } else {
    tmp = null;
  }
  return React.createElement(ScrollLock$Showside.make, {
    children: React.createElement("div", {
      className: CSS$Showside.prefix("py-6 px-8 flex flex-col space-y-4")
    }, React.createElement(QuickViewMediaDetails$Showside.make, {
      media: media,
      activeMediaChild: activeMediaChild,
      productsInMedia: productsInMedia
    }), tmp)
  });
}
QuickViewProductList.displayName = "QuickViewProductList";
var make = React.memo(QuickViewProductList);
export { ProductCompare, make };
/* ProductCompare Not a pure module */